import { useEffect, useState } from "react";

import { MOBILE_SHELL_MQ } from "@/lib/viewport";

/** Tracks the mobile shell breakpoint (max-width 767px). */
export function useMobileShellViewport() {
  const [mobile, setMobile] = useState(
    () =>
      typeof window !== "undefined" &&
      window.matchMedia(MOBILE_SHELL_MQ).matches,
  );

  useEffect(() => {
    const mq = window.matchMedia(MOBILE_SHELL_MQ);
    const sync = () => setMobile(mq.matches);
    sync();
    mq.addEventListener("change", sync);
    return () => mq.removeEventListener("change", sync);
  }, []);

  return mobile;
}
